import React, { useState, useEffect } from 'react';

const DebugDashboard = () => {
  const [debugInfo, setDebugInfo] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        setLoading(true);
        
        // Test multiple endpoints
        const tests = {};
        
        // Test 1: Basic fetch to backend
        try {
          const response1 = await fetch('http://localhost:8080/api/test/budget-data');
          if (response1.ok) {
            const data1 = await response1.json();
            tests.basicFetch = { status: 'Success', data: data1 };
          } else {
            tests.basicFetch = { status: 'Failed', error: `HTTP ${response1.status}` };
          }
        } catch (error) {
          tests.basicFetch = { status: 'Failed', error: error.message };
        }

        // Test 2: Check if backend is running
        try {
          const response2 = await fetch('http://localhost:8080/');
          if (response2.ok) {
            const data2 = await response2.json();
            tests.backendHealth = { status: 'Success', data: data2 };
          } else {
            tests.backendHealth = { status: 'Failed', error: `HTTP ${response2.status}` };
          }
        } catch (error) {
          tests.backendHealth = { status: 'Failed', error: error.message };
        }

        // Test 3: Test inventory endpoint without auth
        try {
          const response3 = await fetch('http://localhost:8080/api/test/inventory-dashboard');
          if (response3.ok) {
            const data3 = await response3.json();
            tests.inventoryEndpoint = { status: 'Success', data: data3 };
          } else {
            tests.inventoryEndpoint = { status: 'Failed', error: `HTTP ${response3.status}` };
          }
        } catch (error) {
          tests.inventoryEndpoint = { status: 'Failed', error: error.message };
        }
        
        setDebugInfo({
          tests,
          currentPath: window.location.pathname,
          currentUrl: window.location.href,
          timestamp: new Date().toISOString()
        });
        
      } catch (error) {
        setDebugInfo({
          generalError: error.message,
          currentPath: window.location.pathname
        });
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, []);

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading debug info...</div>;
  }

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace', background: 'var(--bg)', color: 'var(--text)' }}>
      <h1>🔧 Debug Dashboard</h1>
      
      <div style={{ background: 'var(--panel)', padding: '15px', marginBottom: '20px', borderRadius: '5px', border: '1px solid var(--border)', color: 'var(--text)' }}>
        <h2>📊 API Tests</h2>
        <pre style={{ fontSize: '12px', overflow: 'auto', color: 'var(--text)' }}>
          {JSON.stringify(debugInfo, null, 2)}
        </pre>
      </div>
      
      <div style={{ background: 'var(--panel)', padding: '15px', marginBottom: '20px', borderRadius: '5px', border: '1px solid var(--border)', color: 'var(--text)' }}>
        <h2>🔗 Test Links</h2>
        <ul>
          <li><a href="/inventory-dashboard" style={{ color: 'var(--accent)' }}>Inventory Dashboard</a></li>
          <li><a href="/non-inventory-dashboard" style={{ color: 'var(--accent)' }}>Non-Inventory Dashboard</a></li>
          <li><a href="/" style={{ color: 'var(--accent)' }}>Home Dashboard</a></li>
        </ul>
      </div>

      <div style={{ background: 'var(--panel)', padding: '15px', borderRadius: '5px', border: '1px solid var(--border)', color: 'var(--text)' }}>
        <h2>🛠️ Manual Tests</h2>
        <p>Try these URLs directly in a new tab:</p>
        <ul>
          <li><code>http://localhost:8080/</code> - Backend health</li>
          <li><code>http://localhost:8080/api/test/budget-data</code> - Test endpoint</li>
          <li><code>http://localhost:8080/api/test/inventory-dashboard</code> - Inventory test</li>
        </ul>
      </div>
    </div>
  );
};

export default DebugDashboard;